import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { PLANS, DEFAULT_PLAN, type PlanId } from '../lib/checkout';
export function MobileStickyCta() {
  const [isVisible, setIsVisible] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState<PlanId>(DEFAULT_PLAN);
  if (!isVisible) return null;
  const activePlan = PLANS[selectedPlan];
  const handleCheckout = () => {
    window.location.href = activePlan.checkoutUrl;
  };
  return <AnimatePresence data-id="element-118">
      <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-white border-t-2 border-gold shadow-2xl" data-id="element-119">
        <button onClick={() => setIsVisible(false)} className="absolute -top-8 right-4 bg-navy text-white p-1.5 rounded-t-lg" aria-label="Cerrar" data-id="element-120">
          <X size={16} data-id="element-121" />
        </button>

        <div className="p-3" data-id="element-122">
          {/* Plan Toggle */}
          <div className="flex gap-2 mb-2.5" data-id="element-123">
            <button onClick={() => setSelectedPlan('basic')} className={`flex-1 py-2 px-3 rounded-md text-[12px] font-bold transition-all ${selectedPlan === 'basic' ? 'bg-blue text-white' : 'bg-off-white text-text-muted'}`} data-id="element-124">
              <div className="line-through text-[10px] opacity-60" data-id="element-125">$35.990</div>
              <div className="text-[16px] font-display" data-id="element-126">$19.990</div>
            </button>
            <button onClick={() => setSelectedPlan('total')} className={`flex-1 py-2 px-3 rounded-md text-[12px] font-bold transition-all relative ${selectedPlan === 'total' ? 'bg-gold text-navy' : 'bg-off-white text-text-muted'}`} data-id="element-127">
              <span className="absolute -top-1.5 -right-1.5 bg-gold text-navy text-[8px] font-extrabold px-1.5 py-0.5 rounded-full" data-id="element-128">
                ⭐ MÁS ELEGIDO
              </span>
              <div className="line-through text-[10px] opacity-60" data-id="element-129">$43.990</div>
              <div className="text-[16px] font-display" data-id="element-130">$27.990</div>
            </button>
          </div>

          {/* CTA Button */}
          <button onClick={handleCheckout} className={`block w-full text-center font-display text-[16px] tracking-wide py-3 rounded-lg transition-all ${selectedPlan === 'total' ? 'bg-gold text-navy shadow-gold-glow' : 'bg-blue text-white'}`} data-id="element-131">
            COMPRAR — {activePlan.price}
          </button>
        </div>
      </motion.div>
    </AnimatePresence>;
}